// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.required label::before {
  display: inline-block;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-form-item-label label[title=Title]::before {
  display: inline-block;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-form-item-label label[title=Gender]::before {
  display: inline-block;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.require::before {
  display: inline-block;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  content: "*";
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1; /* Add some spacing between the asterisk and the label */
}

@media only screen and (max-width: 480px) {
  .shadow_consultant .row {
    font-size: 10px;
  }
  .shadow_consultant .row div div {
    padding: 0;
  }
}
.timeslot {
  display: flex;
  gap: 20px;
}

.restore {
  background-color: orange !important;
  border-color: orange !important;
}

.activeButton {
  background-color: green !important;
  border-color: green !important;
}

.deactive {
  background-color: rgb(80, 76, 76) !important;
  border-color: rgb(80, 76, 76) !important;
}

.widthicon {
  width: 20px;
  margin-right: 20px;
  height: 20px;
  cursor: pointer;
}

.ant-modal .ant-modal-content {
  width: 70%;
  padding: 0;
}

.ant-modal .ant-modal-body {
  justify-content: space-between;
  display: flex;
  padding: 1.42857rem;
}

.myCallContainer {
  width: auto !important;
  height: auto !important;
}

/* Dropdown styles */
.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 3px 6px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
  border-radius: 15px;
}

.dropdown-toggle::after {
  display: none !important;
}

.dropdown-toggle:hover {
  background-color: #f8f8f8;
}

.dropdown-option-image {
  width: 30px;
  height: 30px;
  margin-right: 12px;
}

.dropdown-option-label {
  font-weight: bold;
}

.dropdown-caret {
  display: inline-block;
  margin-left: auto;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 8px 0 8px;
  border-color: #999 transparent transparent transparent;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  top: 150%;
  left: 0;
  margin: 0;
  padding: 12px 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  list-style: none;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-12px);
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
}

.dropdown-menu.open {
  opacity: 1;
  visibility: visible;
  display: block;
}

.dropdown-menu li {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-menu li:hover {
  background-color: #f8f8f8;
}

.dropdown-menu li .dropdown-option-image {
  margin-right: 12px;
}

.dropdown-menu li .dropdown-option-label {
  flex-grow: 1;
  font-weight: bold;
}

/* Centering the dropdown */
.dropdown.open .dropdown-menu {
  transform: translateY(0);
}

/* Adjust dropdown width */
.dropdown.open .dropdown-toggle {
  border-radius: 4px 4px 0 0;
  border-bottom: none;
}

.dropdown.open .dropdown-menu {
  border-radius: 0 0 4px 4px;
  border-top: none;
}

.buttons-list {
  align-items: center !important;
}

.card-practitioner {
  transition: transform 0.3s;
}

.card-practitioner:hover {
  transform: scale(1.05); /* You can adjust the scale factor as needed */
}

.read {
  width: auto !important;
}

.cardText {
  text-align: left !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 1rem;
  padding-right: 1rem;
}

.cardborder {
  border: 1px solid rgba(180, 179, 179, 0.7176470588) !important;
}

.cardCVV {
  position: relative !important;
  width: 40%;
}

.cardCVVSvg {
  position: absolute;
  bottom: 6px !important;
  right: 5px !important;
}

.cardBtn {
  padding: 5px 15px;
  border: none !important;
  background-color: black;
  color: white;
  cursor: pointer;
}

.boxHeight {
  display: flex;
  justify-content: center;
  align-items: center;
}

.boxHeight img {
  height: 100%;
  width: 100%;
  /* object-fit: cover;
  aspect-ratio: 16/9; */
}

.aside h2 {
  transform: rotate(270deg);
}

.aside h3 {
  transform: rotate(270deg);
}

@media (max-width: 576px) {
  .aside h2 {
    transform: rotate(0deg);
  }
  .aside h3 {
    transform: rotate(0deg);
  }
}
.selectMultiple .ant-select-selector {
  overflow-x: hidden;
  overflow-y: scroll;
  min-height: 70px;
  padding: auto 20px !important;
}

.ant-select-selection-overflow {
  padding: auto 5px;
}

.ant-radio-group {
  display: block !important;
}

.ant-form-vertical .ant-form-item-label > label {
  width: 100% !important;
}

.line-with-words {
  position: relative;
  display: flex;
  align-items: center;
  color: #761dce;
  font-size: 17px;
}

.line-with-wordss {
  position: relative;
  display: flex;
  align-items: center;
}

.beforeCheck {
  width: 360px !important;
}

.line-with-words::before {
  content: "";
  flex: 1 1;
  border-bottom: 2px solid #761dce; /* Adjust the color and thickness as needed */
  margin-right: 10px; /* Adjust the spacing between the line and words */
  max-width: 235px;
  margin-right: 30px;
}

.line-with-words-2::before {
  margin-right: 40px; /* Adjust the spacing between the line and words */
  max-width: 300px;
}

.line-with-words-3::before {
  margin-right: 10px; /* Adjust the spacing between the line and words */
  max-width: 120px;
}

.text-theme {
  color: #761dce;
}

.line-with-wordss::before {
  content: "";
  flex: 1 1;
  border-bottom: 2px solid #761dce; /* Adjust the color and thickness as needed */
  margin-right: 10px; /* Adjust the spacing between the line and words */
}

#google_translate_element {
  /* Set a smaller width for the dropdown */
  width: 100px;
}

.goog-te-combo {
  /* Set a smaller font size for the dropdown text */
  font-size: 12px;
}

.snip1527 {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  color: #ffffff;
  float: left;
  font-family: "Lato", Arial, sans-serif;
  font-size: 16px;
  margin: 10px 1%;
  max-width: 310px;
  min-width: 250px;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 100%;
}

.snip1527 * {
  box-sizing: border-box;
  transition: all 0.25s ease;
}

.snip1527 img {
  max-width: 100%;
  vertical-align: top;
  position: relative;
}

.snip1527 figcaption {
  padding: 25px 20px 25px;
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.snip1527 figcaption:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  z-index: -1;
}

.snip1527 .date {
  background-color: #fff;
  border-radius: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  min-width: 48px;
  padding: 10px;
  position: absolute;
  right: 15px;
  text-align: center;
  text-transform: uppercase;
  top: -25px;
}

.snip1527 .date span {
  display: block;
  line-height: 10px;
  font-size: 13px;
}

.snip1527 .date .month {
  font-size: 11px;
}

.snip1527 h3,
.snip1527 p {
  margin: 0;
  padding: 0;
}

.snip1527 h3 {
  display: inline-block;
  font-weight: 700;
  letter-spacing: -0.4px;
  margin-bottom: 5px;
}

.snip1527 p {
  font-size: 0.8em;
  line-height: 1.6em;
  margin-bottom: 0px;
}

.custom-jodit .jodit-toolbar-button[aria-label="Show all"],
.custom-jodit .jodit-status-bar-link {
  display: none;
}

.custom-jodit .jodit-ui-spacer {
  width: auto;
  flex: 0 1 !important;
}

.ant-btn-text:not(:disabled):not(.ant-btn-disabled):hover {
  background: #171819 !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,uBAAA;UAAA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,uBAAA;UAAA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,uBAAA;UAAA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,uBAAA;UAAA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA,EAAA,wDAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,mCAAA;EACA,+BAAA;AAAF;;AAGA;EACE,kCAAA;EACA,8BAAA;AAAF;;AAEA;EACE,4CAAA;EACA,wCAAA;AACF;;AAUA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAPF;;AAUA;EACE,UAAA;EACA,UAAA;AAPF;;AAUA;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,uBAAA;AAPF;;AAUA,oBAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sCAAA;EACA,mBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,sDAAA;AAPF;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,wCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,wEAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,UAAA;EACA,mBAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,YAAA;EACA,iBAAA;AAPF;;AAUA,2BAAA;AACA;EACE,wBAAA;AAPF;;AAUA,0BAAA;AACA;EACE,0BAAA;EACA,mBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,gBAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,0BAAA;AAPF;;AAUA;EACE,sBAAA,EAAA,8CAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,8DAAA;AAPF;;AAUA;EACE,6BAAA;EACA,UAAA;AAPF;;AAUA;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAPF;;AAUA;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAWA;EACE,YAAA;EACA,WAAA;EACA;uBAAA;AAPF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE;IACE,uBAAA;EARF;EAWA;IACE,uBAAA;EATF;AACF;AAwBA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AAtBF;;AAyBA;EACE,iBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,sBAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,SAAA;EACA,gCAAA,EAAA,6CAAA;EACA,kBAAA,EAAA,kDAAA;EACA,gBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,kBAAA,EAAA,kDAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,kBAAA,EAAA,kDAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,SAAA;EACA,gCAAA,EAAA,6CAAA;EACA,kBAAA,EAAA,kDAAA;AAtBF;;AAyBA;EACE,yCAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,kDAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,uCAAA;EACA,cAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAtBF;;AAyBA;EAEE,sBAAA;EAEA,0BAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EAKA,YAAA;EACA,WAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EAEA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;;EAEE,SAAA;EACA,UAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AA3BF;;AAuCA;;EAEE,aAAA;AApCF;;AAuCA;EACE,WAAA;EACA,oBAAA;AApCF;;AAuCA;EACE,8BAAA;EACA,yBAAA;AApCF","sourcesContent":[".required label::before {\n  display: inline-block;\n  margin-inline-end: 4px;\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n\n.ant-form-item-label label[title='Title']::before {\n  display: inline-block;\n  margin-inline-end: 4px;\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n\n.ant-form-item-label label[title='Gender']::before {\n  display: inline-block;\n  margin-inline-end: 4px;\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n\n.require::before {\n  display: inline-block;\n  margin-inline-end: 4px;\n  content: '*';\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1; /* Add some spacing between the asterisk and the label */\n}\n\n@media only screen and (max-width: 480px) {\n  .shadow_consultant .row {\n    font-size: 10px;\n  }\n  .shadow_consultant .row div div {\n    padding: 0;\n  }\n}\n\n.timeslot {\n  display: flex;\n  gap: 20px;\n}\n\n.restore {\n  background-color: orange !important;\n  border-color: orange !important;\n}\n\n.activeButton {\n  background-color: green !important;\n  border-color: green !important;\n}\n.deactive {\n  background-color: rgb(80, 76, 76) !important;\n  border-color: rgb(80, 76, 76) !important;\n}\n\n// .ant-carousel .slick-dots li.slick-active button {\n//   background-color: #ff4d4f;\n// }\n\n// .ant-carousel .slick-dots li {\n//   background-color: green;\n// }\n\n.widthicon {\n  width: 20px;\n  margin-right: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.ant-modal .ant-modal-content {\n  width: 70%;\n  padding: 0;\n}\n\n.ant-modal .ant-modal-body {\n  justify-content: space-between;\n  display: flex;\n  padding: 1.42857rem;\n}\n\n.myCallContainer {\n  width: auto !important;\n  height: auto !important;\n}\n\n/* Dropdown styles */\n.dropdown {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.dropdown-toggle {\n  display: flex;\n  align-items: center;\n  padding: 3px 6px;\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  border-radius: 15px;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.dropdown-toggle:hover {\n  background-color: #f8f8f8;\n}\n\n.dropdown-option-image {\n  width: 30px;\n  height: 30px;\n  margin-right: 12px;\n}\n\n.dropdown-option-label {\n  font-weight: bold;\n}\n\n.dropdown-caret {\n  display: inline-block;\n  margin-left: auto;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 8px 0 8px;\n  border-color: #999 transparent transparent transparent;\n}\n\n.dropdown-menu {\n  position: absolute;\n  width: 100%;\n  top: 150%;\n  left: 0;\n  margin: 0;\n  padding: 12px 0;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  list-style: none;\n  z-index: 1;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-12px);\n  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;\n  max-height: 200px;\n  overflow-y: auto;\n  border-radius: 4px;\n}\n\n.dropdown-menu.open {\n  opacity: 1;\n  visibility: visible;\n  display: block;\n}\n\n.dropdown-menu li {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 12px 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.dropdown-menu li:hover {\n  background-color: #f8f8f8;\n}\n\n.dropdown-menu li .dropdown-option-image {\n  margin-right: 12px;\n}\n\n.dropdown-menu li .dropdown-option-label {\n  flex-grow: 1;\n  font-weight: bold;\n}\n\n/* Centering the dropdown */\n.dropdown.open .dropdown-menu {\n  transform: translateY(0);\n}\n\n/* Adjust dropdown width */\n.dropdown.open .dropdown-toggle {\n  border-radius: 4px 4px 0 0;\n  border-bottom: none;\n}\n\n.dropdown.open .dropdown-menu {\n  border-radius: 0 0 4px 4px;\n  border-top: none;\n}\n\n.buttons-list {\n  align-items: center !important;\n}\n\n.card-practitioner {\n  transition: transform 0.3s;\n}\n\n.card-practitioner:hover {\n  transform: scale(1.05); /* You can adjust the scale factor as needed */\n}\n\n.read {\n  width: auto !important;\n}\n\n.cardText {\n  text-align: left !important;\n  padding-bottom: 0 !important;\n  margin-bottom: 0 !important;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.cardborder {\n  border: 1px solid #b4b3b3b7 !important;\n}\n\n.cardCVV {\n  position: relative !important;\n  width: 40%;\n}\n\n.cardCVVSvg {\n  position: absolute;\n  bottom: 6px !important;\n  right: 5px !important;\n}\n\n.cardBtn {\n  padding: 5px 15px;\n  border: none !important;\n  background-color: black;\n  color: white;\n  cursor: pointer;\n}\n\n.boxHeight {\n  // height: 380px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxHeight img {\n  height: 100%;\n  width: 100%;\n  /* object-fit: cover;\n  aspect-ratio: 16/9; */\n}\n\n.aside h2 {\n  transform: rotate(270deg);\n}\n\n.aside h3 {\n  transform: rotate(270deg);\n}\n\n@media (max-width: 576px) {\n  .aside h2 {\n    transform: rotate(0deg);\n  }\n\n  .aside h3 {\n    transform: rotate(0deg);\n  }\n}\n\n// .digital__Container .col-md-3 {\n//   max-width: 23% !important;\n// }\n// .hoverLifestyle {\n//   transition: 0.3s all ease-in-out;\n// }\n// .hoverLifestyle:hover {\n//   transform: scale(1.1);\n//   z-index: 20;\n//   cursor: pointer;\n// }\n\n.selectMultiple .ant-select-selector {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  min-height: 70px;\n  padding: auto 20px !important;\n}\n\n.ant-select-selection-overflow {\n  padding: auto 5px;\n}\n\n.ant-radio-group {\n  display: block !important;\n}\n\n.ant-form-vertical .ant-form-item-label > label {\n  width: 100% !important;\n}\n\n.line-with-words {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: #761dce;\n  font-size: 17px;\n  // width: 100%;\n}\n.line-with-wordss {\n  position: relative;\n  display: flex;\n  align-items: center;\n  // width: 100%;\n}\n.beforeCheck {\n  width: 360px !important;\n}\n\n.line-with-words::before {\n  content: '';\n  flex: 1;\n  border-bottom: 2px solid #761dce; /* Adjust the color and thickness as needed */\n  margin-right: 10px; /* Adjust the spacing between the line and words */\n  max-width: 235px;\n  margin-right: 30px;\n}\n\n.line-with-words-2::before {\n  margin-right: 40px; /* Adjust the spacing between the line and words */\n  max-width: 300px;\n}\n\n.line-with-words-3::before {\n  margin-right: 10px; /* Adjust the spacing between the line and words */\n  max-width: 120px;\n}\n\n.text-theme {\n  color: #761dce;\n}\n\n.line-with-wordss::before {\n  content: '';\n  flex: 1;\n  border-bottom: 2px solid #761dce; /* Adjust the color and thickness as needed */\n  margin-right: 10px; /* Adjust the spacing between the line and words */\n}\n\n#google_translate_element {\n  /* Set a smaller width for the dropdown */\n  width: 100px;\n}\n\n.goog-te-combo {\n  /* Set a smaller font size for the dropdown text */\n  font-size: 12px;\n}\n\n.snip1527 {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);\n  color: #ffffff;\n  float: left;\n  font-family: 'Lato', Arial, sans-serif;\n  font-size: 16px;\n  margin: 10px 1%;\n  max-width: 310px;\n  min-width: 250px;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 100%;\n}\n\n.snip1527 * {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n\n.snip1527 img {\n  max-width: 100%;\n  vertical-align: top;\n  position: relative;\n}\n\n.snip1527 figcaption {\n  padding: 25px 20px 25px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n}\n\n.snip1527 figcaption:before {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #000;\n  content: '';\n  // background: -moz-linear-gradient(90deg, #700877 0%, #ff2759 100%, #ff2759 100%);\n  // background: -webkit-linear-gradient(90deg, #700877 0%, #ff2759 100%, #ff2759 100%);\n  // background: linear-gradient(90deg, #700877 0%, #ff2759 100%, #ff2759 100%);\n\n  opacity: 0.4;\n  z-index: -1;\n}\n\n.snip1527 .date {\n  background-color: #fff;\n  border-radius: 10px;\n  color: #000;\n  font-size: 18px;\n  font-weight: 700;\n  // min-height: 20px;\n  min-width: 48px;\n  padding: 10px;\n  position: absolute;\n  right: 15px;\n  text-align: center;\n  text-transform: uppercase;\n  top: -25px;\n}\n\n.snip1527 .date span {\n  display: block;\n  line-height: 10px;\n  font-size: 13px;\n}\n\n.snip1527 .date .month {\n  font-size: 11px;\n}\n\n.snip1527 h3,\n.snip1527 p {\n  margin: 0;\n  padding: 0;\n}\n\n.snip1527 h3 {\n  display: inline-block;\n  font-weight: 700;\n  letter-spacing: -0.4px;\n  margin-bottom: 5px;\n}\n\n.snip1527 p {\n  font-size: 0.8em;\n  line-height: 1.6em;\n  margin-bottom: 0px;\n}\n\n// .snip1527 a {\n//   left: 0;\n//   right: 0;\n//   top: 0;\n//   bottom: 0;\n//   position: absolute;\n//   z-index: 1;\n// }\n\n.custom-jodit .jodit-toolbar-button[aria-label='Show all'],\n.custom-jodit .jodit-status-bar-link {\n  display: none;\n}\n\n.custom-jodit .jodit-ui-spacer {\n  width: auto;\n  flex: 0 !important;\n}\n\n.ant-btn-text:not(:disabled):not(.ant-btn-disabled):hover {\n  background: #171819 !important;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
